import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ProductoService } from '../../../services/producto/producto.service';
import * as _ from 'lodash';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

import { IArchivo } from '../../../../model/interface/IArchivo';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import { ICertificacion } from '../../../../model/interface/ICertificacion';
import {Documento} from '../../../../model/class/Documento';
import { AuthService } from '../../../services/auth/auth.service';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import {isUndefined} from 'util';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  animations: [

    trigger('visibility-codes', [
      state('in', style({
        'opacity': '1',
        'display': 'visible',
      })),
      state('out', style({
        'opacity': '0',
        'display': 'none',
      })),
      transition('in => out', animate('300ms ease-in')),
      transition('out => in', animate('300ms ease-out'))
    ])
  ]
})
export class ProductoComponent implements OnInit {
  isLogged: boolean;
  productoId: number;
  desdeCategoriaId: number;
  desdeCategoria: any;
  porductosCategoria: any[] = [];
  producto: any = {marca: {}};
  categorias: any[] = [];
  categoriaPadre: any = {};
  categoriaHija: any = {};
  colores: any[] = [];
  codigos: ElementoCarro[] = [];
  certificaciones: ICertificacion[];
  complementarios: ElementoCarro[] = [];
  relacionados: ElementoCarro[] = [];
  tablaVertical = true;

  viewEctraCol = false;

  productoEnCarro: ElementoCarro;

  archivosGaleria: IArchivo[] = [];
  archivosDescargables: Documento[] = [];

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  avatarProduct: any;

  statusCodes = 'out';

  loadres = {
    producto: false,
    files: false,
  };

  slideConfig = {'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': false, 'dots': true};
  slideConfMiniBrowser = {'slidesToShow': 6, 'slidesToScroll': 6, 'arrows': true, 'dots': false};

  constructor(
    private _productoService: ProductoService,
    private _categoriaService: CategoriaService,
    private activatedRoute: ActivatedRoute,
    private _carritoService: CarritoService,
    private _authService: AuthService,
  ) {
    this.activatedRoute.params.subscribe( params => {
      this.limpiar();
      this.productoId = Number(params.id);
      if (params.ct) {
        this.desdeCategoriaId = Number(params.ct);
      }
      this.getProducto();
    });
  }

  ngOnInit() {
    this.isLogged = this._authService.isLoged();
  }

  limpiar() {
    this.desdeCategoria = undefined;
    this.porductosCategoria = [];
    this.producto = {marca: {}};
    this.categorias = [];
    this.categoriaPadre = {};
    this.categoriaHija = {};
    this.colores = [];
    this.codigos = [];
    this.certificaciones = [];
    this.complementarios = [];
    this.relacionados = [];
    this.productoEnCarro = undefined;
    this.archivosGaleria = [];
    this.archivosDescargables = [];
    this.galleryOptions = [];
    this.galleryImages = [];
    this.statusCodes = 'out';
    this.loadres = {
      producto: false,
      files: false
    };
  }

  getProducto() {
    this.producto = {marca: {}};
    this.categorias = [];
    this.colores = [];
    this.certificaciones = [];
    this.codigos = [];
    this.complementarios = [];
    this.relacionados = [];
    this.archivosGaleria = [];
    this.archivosDescargables = [];
    this.galleryOptions = [];
    this.galleryImages = [];
    this.statusCodes = 'out';

    this.loadres.producto = false;

    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        imageSize: 'contain',
        imageArrows: false,
        arrowPrevIcon: 'fa fa-chevron-left',
        arrowNextIcon: 'fa fa-chevron-right',
        layout: 'thumbnails-top'
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];


    this._productoService.get(this.productoId)
      .subscribe( data => {
        this.producto = data;
        this.loadres.producto = true;
        if (this.producto.especificaciones) {
          if (this.producto.especificaciones.caracteristicas) {
            for (const cat of this.producto.especificaciones.caracteristicas) {
              if (cat.otro && cat.otro !== '') {
                this.viewEctraCol = true;
              }
            }
          }

          if (!this.producto.especificaciones.esVertical) {
            this.tablaVertical = false;
          }
        };

      });

    this._productoService.getCategorias(this.productoId)
      .subscribe( (data: any) => {
        console.log('Categoras', data);
        const carintermedias = [];
        const categoriasHijas = data;

        for (const catHija of data) {
          carintermedias.push(catHija.categoria);
        }

        this.categorias = _.uniqBy(carintermedias, 'id');
        this.categoriaHija = data[0];

        // Aca me traigo los prod de las categorias hijas
        let catHijaId = this.desdeCategoriaId;
        if (!catHijaId && data[0]) {
          catHijaId = data[0].id;
          this.desdeCategoria = data[0];
        } else {
          this.desdeCategoria = _.find(categoriasHijas, {id: catHijaId});
          console.log('desdeCategoria', this.desdeCategoria);
          console.log('this.categorias', this.categorias);
        }

        if (this.desdeCategoria) {
          this._categoriaService.getProductos(this.desdeCategoria.id)
            .subscribe(
              (respProd) => {
                console.log('Estos son los productos de la categoria', respProd);


                const prods = respProd;
                _.remove(prods, {id: this.producto.id});
                this.porductosCategoria = prods;
              }, (errorProd) => {
                console.log('Error al traer los productos de la categoria', errorProd);
              }
            );
        }
        console.log('Para mostrar el nuevo carrusel', catHijaId);


        this._categoriaService.getPadres().subscribe(resp => {
          const categoriaPadre = _.filter(resp, (item) => {
            return item.id === this.categorias[0].categoriaId;
          });
          this.categoriaPadre = categoriaPadre[0];
        });
    });

    this._productoService.getColores(this.productoId)
      .subscribe( data => {
        this.colores = data;
      });

    this._productoService.getCodigos(this.productoId)
      .subscribe( data => {
        this.codigos = this._carritoService.enriquecerCodigos(data, this.producto);
        this.producto.codigos = data;

        this.productoEnCarro = this._carritoService.enriquecerProductos([this.producto])[0];

        this._carritoService.carroProductos
          .subscribe( () => {
            this.productoEnCarro = this._carritoService.actualizarProductos([this.productoEnCarro])[0];
          });
      });

    this._productoService.getCertificaciones(this.productoId)
      .subscribe( data => {
        this.certificaciones = data;
      });

    this._productoService.getProductosComplementarios(this.productoId)
      .subscribe( data => {
        this.complementarios = this._carritoService.enriquecerProductos(data);
      });

    this._productoService.getProductosRelacionados(this.productoId)
      .subscribe( data => {
        this.relacionados = this._carritoService.enriquecerProductos(data);
      });

    this._carritoService.carroProductos
      .subscribe( data => {

        this.complementarios = this._carritoService.actualizarProductos(this.complementarios);
        this.relacionados = this._carritoService.actualizarProductos(this.relacionados);
        this.codigos = this._carritoService.actualizarProductos(this.codigos);
      });

    this._productoService.getFichas(this.productoId)
      .subscribe(
        (resp) => {
          for (const iCatDoc of resp.data) {
            this.archivosDescargables.push(new Documento(iCatDoc));
          }
        }
      );

    this._productoService.getArchivos(this.productoId)
      .subscribe( data => {

        const agrupados = _.groupBy(data, 'tipo');

        if (agrupados.PROD_IMAGEN_PRINCIPAL) {

          _.each(agrupados.PROD_IMAGEN_PRINCIPAL, archivo => {
            const auxImg = {
              small: archivo.url,
              medium: archivo.url,
              big: archivo.url,
            };

            this.galleryImages.push(auxImg);
          });
        }

        if (agrupados.PROD_IMAGEN_AVATAR && agrupados.PROD_IMAGEN_AVATAR[0]) {
          const auxImg = {
            small: agrupados.PROD_IMAGEN_AVATAR[0].url,
            medium: agrupados.PROD_IMAGEN_AVATAR[0].url,
            big: agrupados.PROD_IMAGEN_AVATAR[0].url,
          };

          this.avatarProduct = agrupados.PROD_IMAGEN_AVATAR[0].url;

          this.galleryImages.unshift(auxImg);
        }

        if (agrupados.PROD_IMAGEN_GALERIA) {
          this.archivosGaleria = _.union(this.archivosGaleria, agrupados.PROD_IMAGEN_GALERIA);
        }

        if (agrupados.PROD_VIDEO_GALERIA) {
          this.archivosGaleria = _.union(this.archivosGaleria, agrupados.PROD_VIDEO_GALERIA);
        }

        this.archivosGaleria = _.orderBy(this.archivosGaleria, 'orden');

        this.loadres.files = true;
      });
  }


  verCodigos() {
    this.statusCodes = this.statusCodes === 'out' ? 'in' : 'out';
  }

  agregarProductoCotizacion(producto: ElementoCarro) {
    producto.producto.imagen = this.avatarProduct;
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

  eliminarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.eliminarProducto(clon);
  }

  onClickedOutside() {
    this.statusCodes = 'out';
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/producto/producto.component.ts